import { useState, type FormEvent } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate, useRouteContext } from '@tanstack/react-router';
import { BRAND_NAME_MAX_LENGTH } from '@studio/contracts';
import { setActiveBrand } from '@/lib/active-brand';
import { supabase } from '@/lib/supabase';
import { trpc } from '@/lib/trpc';
import { Mast } from '@/components/sign-in-card';

/** A signed-in account with no workspace names its brand and the studio opens on it. */
export function WelcomePage() {
  const { me } = useRouteContext({ from: '/welcome' });
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const create = useMutation(trpc.onboarding.create.mutationOptions({
    onSuccess: (data) => {
      setActiveBrand(data.brandSlug);
      // A full load: the router context resolved this account without a workspace.
      location.assign('/');
    },
  }));
  const submit = (e: FormEvent): void => {
    e.preventDefault();
    create.mutate({ brandName: name.trim() });
  };
  const signOut = async (): Promise<void> => {
    await supabase().auth.signOut();
    await navigate({ to: '/sign-in' });
  };
  return (
    <main className="signin">
      <div className="card">
        <Mast />
        <div>
          <h1>Name your brand</h1>
          <div className="lead">Signed in as {me.email}. The brand is where your footage lives; you can add more later.</div>
        </div>
        <form className="stack" onSubmit={submit}>
          <label className="field lg">
            <input type="text" required autoFocus maxLength={BRAND_NAME_MAX_LENGTH} placeholder="Brand name" value={name} onChange={(e) => setName(e.target.value)} aria-label="Brand name" />
          </label>
          <button type="submit" className="btn lg primary" disabled={create.isPending || !name.trim()}>{create.isPending ? 'Opening…' : 'Open the studio'}</button>
          <button type="button" className="btn quiet" onClick={() => void signOut()}>Sign out</button>
        </form>
        {create.isError && <div className="error" role="alert">{create.error.message}</div>}
        <p className="note">Invited to a team? Sign in with the address the invite went to.</p>
      </div>
    </main>
  );
}
